
$(function() {

    // info button transitions
    $("#navbarDropdown").hover(function() {
      $("#menuShowHover").toggleClass("show", 300);
    });
  });

  
